export default __webpack_public_path__ + "static/taniyuk-logo-stacked-cf8fe59c85a3cb07284accd81bc237d3.svg";